import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';

export const FormHeader = ({ title, description, networkName, networkLogo }) => (
  <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '4px',
      }}
    >
      <Text
        sx={{
          fontSize: '18px',
          fontWeight: '600',
          color: 'text.dark',
          lineHeight: '24px',
        }}
      >
        {title}
      </Text>
      <Text
        sx={{
          fontSize: '16px',
          color: 'text.main',
          lineHeight: '24px',
        }}
      >
        {description}
      </Text>
    </Flex>
    <Flex sx={{ alignItems: 'center', gap: '8px' }}>
      <ProfilePicture
        imageUrl={networkLogo}
        name={networkName}
        variant="square"
        width="48px"
        height="48px"
        sx={{ flexShrink: 0 }}
      />
      <Text
        sx={{
          fontSize: '14px',
          color: 'text.main',
        }}
      >
        <Text as="span">A talent community by </Text>
        <Text as="span" sx={{ fontWeight: '500' }}>
          {networkName}
        </Text>
      </Text>
    </Flex>
  </Flex>
);

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  networkName: PropTypes.string.isRequired,
  networkLogo: PropTypes.string,
};

FormHeader.defaultProps = {
  description: '',
  networkLogo: null,
};
